import type {
  Collab,
  Filters,
  MemberRow,
  ReportResponse,
  ReportType,
  Summary
} from "./types";

const people = {
  owner: {
    id: "1",
    fullName: "Марина Волкова",
    email: "marina@example.test",
    phone: "",
    position: "Руководитель проектов",
    userType: "user" as const,
    lastActivityAt: "2026-07-23T09:30:00.000Z",
    role: "owner" as const
  },
  moderator: {
    id: "2",
    fullName: "Алексей Орлов",
    email: "alexey@example.test",
    phone: "",
    position: "Координатор",
    userType: "user" as const,
    lastActivityAt: "2026-07-18T13:00:00.000Z",
    role: "moderator" as const
  },
  guest: {
    id: "3",
    fullName: "Анна Смирнова",
    email: "anna.partner@example.test",
    phone: "",
    position: "Маркетолог",
    userType: "guest" as const,
    lastActivityAt: "2026-02-10T08:00:00.000Z",
    role: "member" as const
  },
  member: {
    id: "4",
    fullName: "Игорь Петров",
    email: "igor@example.test",
    phone: "",
    position: "Менеджер по продажам",
    userType: "user" as const,
    lastActivityAt: null,
    role: "member" as const
  }
};

const collabs: Collab[] = [
  {
    id: "42",
    name: "Запуск партнёрской программы",
    status: "active",
    createdAt: "2026-01-17T10:00:00.000Z",
    owner: people.owner,
    moderators: [people.moderator],
    members: [people.owner, people.moderator, people.guest]
  },
  {
    id: "57",
    name: "Новая продуктовая линейка",
    status: "active",
    createdAt: "2026-03-05T10:00:00.000Z",
    owner: people.owner,
    moderators: [],
    members: [people.owner, people.member]
  },
  {
    id: "19",
    name: "Архив: конференция 2025",
    status: "archive",
    createdAt: "2025-06-10T10:00:00.000Z",
    owner: people.moderator,
    moderators: [people.owner],
    members: [people.moderator, people.guest]
  }
];

export const demoSummary: Summary = {
  collabs: collabs.length,
  uniqueMembers: 4,
  uniqueGuests: 1,
  generatedAt: new Date().toISOString(),
  positions: [
    "Координатор",
    "Маркетолог",
    "Менеджер по продажам",
    "Руководитель проектов"
  ]
};

export function demoReport(
  type: ReportType,
  filters: Filters
): ReportResponse {
  const filteredCollabs = collabs.filter((collab) =>
    filters.status === "all" ? true : collab.status === filters.status
  );
  const search = filters.search.toLocaleLowerCase("ru");
  let rows: Collab[] | MemberRow[];
  if (type === "collabs") {
    rows = filteredCollabs.filter((collab) =>
      [collab.name, collab.owner.fullName, ...collab.members.map((person) => person.fullName)]
        .join(" ")
        .toLocaleLowerCase("ru")
        .includes(search)
    );
  } else {
    rows = filteredCollabs.flatMap((collab) =>
      collab.members
        .filter((person) => type !== "guests" || person.userType === "guest")
        .filter(
          (person) =>
            filters.position === "all" ||
            (filters.position === "__missing"
              ? !person.position
              : person.position === filters.position)
        )
        .filter((person) =>
          [collab.name, person.fullName, person.position]
            .join(" ")
            .toLocaleLowerCase("ru")
            .includes(search)
        )
        .map((member) => ({
          collab: {
            id: collab.id,
            name: collab.name,
            status: collab.status,
            createdAt: collab.createdAt,
            owner: collab.owner
          },
          member,
          absenceMonths: member.lastActivityAt
            ? Math.max(
                0,
                Math.floor(
                  (Date.now() - new Date(member.lastActivityAt).getTime()) /
                    (30.44 * 24 * 60 * 60 * 1000)
                )
              )
            : null
        }))
    );
  }
  return {
    generatedAt: demoSummary.generatedAt,
    total: rows.length,
    page: 1,
    pageSize: 50,
    rows
  };
}
